const ORG_USING_WAF = new Set(["icici", "icicipoc"]);

export const API_TYPES = {
  /** Test Case Management v2 endpoints */
  TCM_V2: "tcm-v2",

  /** Job execution and management endpoints */
  JOB_RUNNER: "job-runner",

  JOB_SETTINGS: "job-settings",

  JOB_SUBMIT: "job-submit",

  /** Legacy v1 endpoints */
  V1_LEGACY: "v1-legacy",

  /** Authentication endpoints */
  AUTH: "auth",
  ACCESS_CONTROL: "access-control",

  /** Default organization-specific base URL */
  DEFAULT: "default",

  /** CRUD endpoints for AWS Secrets**/
  AWS_SECRETS: "aws-secrets",

  /** Raise issue endpoints via jira apis**/
  JIRA_ISSUE: "jira",

  /** Tags related endpoints**/
  TAGS: "tags",

  /** Fetch repo files and folders**/
  VERSION_CONTROL_SYSTEM: "vcs",

  /** Fetch repo files and folders**/
  FILE_CACHE: "cache",

  /** Get project based configurations **/
  PROJECT_CONFIGS: "project-configs",

  /** Optics endpoints */
  OPTICS: "optics",

  /** Report generation endpoints */
  REPORTS: "reports",

  /** Session screenshot data endpoints */
  SESSION_SCREENSHOTS: "session-screenshots",

  CODEGEN: "codegen",

  DEVICES: "devices",

  BROWSERS: "browsers",

  TEST_STUDIO: "test-studio",
};

const DEFAULT_ORGANIZATION = "api-dev";

export const getBaseURL = (
  organization = DEFAULT_ORGANIZATION,
  apiType = API_TYPES.DEFAULT
) => {
  switch (apiType) {
    case API_TYPES.TCM_V2: // used in generating a robot suite
      return `https://${organization}-api.mozark.ai/v2`;
    case API_TYPES.JOB_RUNNER:
      return `https://${organization}-api.mozark.ai/job-runner`;
    case API_TYPES.JOB_SETTINGS:
      return `https://${organization}-api.mozark.ai/v3/job-settings`;
    case API_TYPES.JOB_SUBMIT:
      return `https://${organization}-api.mozark.ai/v3/jobs`;
    case API_TYPES.V1_LEGACY:
      return `https://${organization}-api.mozark.ai/v1`;
    case API_TYPES.OPTICS:
      return `https://${organization}-optics-api.mozark.ai`;
    case API_TYPES.AUTH:
      return `https://apiv4.mozark.ai/auth`;
    case API_TYPES.ACCESS_CONTROL:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/access-control`
        : `https://orchestrator-api.mozark.ai/access-control`;
    case API_TYPES.AWS_SECRETS:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/aws-secrets`
        : `https://orchestrator-api.mozark.ai/aws-secrets`;
    case API_TYPES.JIRA_ISSUE:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/jira`
        : `https://orchestrator-api.mozark.ai/jira`;
    case API_TYPES.VERSION_CONTROL_SYSTEM:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/vcs`
        : `https://orchestrator-api.mozark.ai/vcs`;
    case API_TYPES.FILE_CACHE:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/cache`
        : `https://orchestrator-api.mozark.ai/cache`;
    case API_TYPES.PROJECT_CONFIGS:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/project-configs`
        : `https://orchestrator-api.mozark.ai/project-configs`;
    case API_TYPES.TAGS:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/tags`
        : `https://orchestrator-api.mozark.ai/tags`;
    case API_TYPES.REPORTS:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/reports`
        : `https://orchestrator-api.mozark.ai/reports`;
    case API_TYPES.SESSION_SCREENSHOTS:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/session-screenshots`
        : `https://orchestrator-api.mozark.ai/session-screenshots`;
    case API_TYPES.CODEGEN:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/codegen`
        : `https://orchestrator-api.mozark.ai/codegen`;
    case API_TYPES.DEVICES:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/devices`
        : `https://orchestrator-api.mozark.ai/devices`;
    case API_TYPES.BROWSERS:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/browsers`
        : `https://orchestrator-api.mozark.ai/browsers`;
    case API_TYPES.TEST_STUDIO:
      return ORG_USING_WAF.has(organization)
        ? `https://${organization}-orchestrator.mozark.ai/test-studio`
        : `https://orchestrator-api.mozark.ai/test-studio`;
    case API_TYPES.DEFAULT:
    default:
      return `https://api-dev.mozark.ai`;
  }
};
